import { render, staticRenderFns } from "./imgDialog.vue?vue&type=template&id=07b68fce&scoped=true"
import script from "./imgDialog.vue?vue&type=script&lang=js"
export * from "./imgDialog.vue?vue&type=script&lang=js"
import style0 from "./imgDialog.vue?vue&type=style&index=0&id=07b68fce&prod&lang=scss&scoped=true"
import style1 from "./imgDialog.vue?vue&type=style&index=1&id=07b68fce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b68fce",
  null
  
)

export default component.exports